import { ResidentContact } from './resident-contact';

export class ResidentContactList {
  members: Array<ResidentContact>;

  constructor(members: Array<ResidentContact> = []) {
    this.members = members;
  }
}
